import { HttpClient } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { httpHeaders } from '../../../environments/httpHeaders';
import {EventEmitter, Injectable, Output} from '@angular/core';
import { constants } from '../../../environments/constants';
import { User } from '../../user/user.model';

const apiUrl = environment.apiUrl;
const headers = httpHeaders.headers;

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private user: User;
  public emailToChangePassword = '';
  @Output() userUpdated = new EventEmitter<any>();

  constructor(
    private _http: HttpClient,
    private jwtHelper: JwtHelperService
  ) {
    this.user = this.readUserFromLocalStorage();
  }

  public readUserFromLocalStorage() {
    try {
      return JSON.parse(localStorage.getItem(constants.CINETEL_USER));
    } catch (e) {
      return null;
    }
  }

  public updateUserInLocalStorage(user: User) {
    localStorage.setItem(constants.CINETEL_USER, JSON.stringify(user));
    this.userUpdated.emit(user);
  }

  public signInUser(data) {
    const endPoint = '/api/token';

    return this._http.post(apiUrl + endPoint, data, {headers: headers, observe: 'response'}).pipe(
      map(response => {
          this.user = new User(response.body);
          if (this.user && this.user.accessToken) {
            localStorage.setItem(constants.CINETEL_USER, JSON.stringify(this.user));
            localStorage.setItem(constants.CINETEL_TOKEN, this.user.accessToken);
            localStorage.setItem(constants.CINETEL_TOKEN_REFRESH, this.user.refreshToken);
          }
          return this.user;
        }
      )
    );
  }

  public recoverPassword(email) {
    const endPoint = '/api/admin/forgotpassword';
    const request = {
      email: email
    };
    return this._http.post(apiUrl + endPoint, request, {headers: headers});
  }

  public changePassword(data) {
    const endPoint = '/api/admin/changepassword';
    return this._http.post(apiUrl + endPoint, data, {headers: headers});
  }

  public resetPassword(resetToken, newPassword) {
    const endPoint = '/api/admin/resetpassword';
    const request = {
      resetToken,
      newPassword
    };
    return this._http.post(apiUrl + endPoint, request, {headers: headers});
  }

  public async logOutUser() {
    if (this.user && this.user.accessToken) {
      const endPoint = '/api/token/logout';
      await this._http.post(apiUrl + endPoint, null, {headers: headers, observe: 'response'}).toPromise();
    }
    this.clearStorage();
  }

  public clearStorage() {
    localStorage.removeItem(constants.CINETEL_USER);
    localStorage.removeItem(constants.CINETEL_TOKEN);
    localStorage.removeItem(constants.CINETEL_TOKEN_REFRESH);
  }

  public isLoggedIn() {
    this.user = this.readUserFromLocalStorage();
    return !!this.user && (this.user.accessToken);
  }

  public isTokenExpired() {
    return this.jwtHelper.isTokenExpired(this.user.accessToken);
  }

  public refreshToken() {
    const endPoint = '/api/token/refresh-token';
    const request = {
      'refreshToken': this.user.refreshToken
    }
    return this._http.post(apiUrl + endPoint, request, {headers: headers, observe: 'response'}).pipe(map((resp: any) => {
      this.user.accessToken = resp.body.accessToken;
      this.user.refreshToken = resp.body.refreshToken;
      localStorage.setItem(constants.CINETEL_USER, JSON.stringify(this.user));
      localStorage.setItem(constants.CINETEL_TOKEN, this.user.accessToken);
      localStorage.setItem(constants.CINETEL_TOKEN_REFRESH, this.user.refreshToken);
      return this.user.accessToken;
    }, error => {
      return false;
    }));
  }

  async refreshTokenTrigger() {
    return await this.refreshToken().toPromise();
  }



}
